/**
 * @license @tabler/icons-react v3.44.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M9 6l11 0", "key": "svg-0" }], ["path", { "d": "M9 12l11 0", "key": "svg-1" }], ["path", { "d": "M9 18l11 0", "key": "svg-2" }], ["path", { "d": "M5 6l0 .01", "key": "svg-3" }], ["path", { "d": "M5 12l0 .01", "key": "svg-4" }], ["path", { "d": "M5 18l0 .01", "key": "svg-5" }]];
const IconList = createReactComponent("outline", "list", "List", __iconNode);

export { __iconNode, IconList as default };
//# sourceMappingURL=IconList.mjs.map
